<template>
	<div>
		<b-breadcrumb>
			<b-breadcrumb-item text="Home" to="/"/>
			<b-breadcrumb-item text="User Profile" to="/user/profile"/>
			<b-breadcrumb-item text="Password" :active="true"/>
		</b-breadcrumb>
		<b-container>
			<b-form @submit="changePassword">
				<b-row>
					<b-col>
						<b-form-group id="oldPassword-group" label="Current Password:" label-for="oldPassword" description="Enter your current password">
							<b-form-input id="oldPassword" type="password" v-model="oldPassword" autofocus required placeholder=""></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-group id="newPassword-group" label="New Password:" label-for="newPassword" description="Enter a new password">
							<b-form-input id="newPassword" type="password" v-model="newPassword" required placeholder=""></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-group id="verifyPassword-group" label="Verify Password:" label-for="verifyPassword" description="Re-enter new password">
							<b-form-input id="verifyPassword" type="password" v-model="verifyPassword" required placeholder=""></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col class="d-flex justify-content-end">
						<b-button type="Submit" variant="primary">Update</b-button>
					</b-col>
				</b-row>
			</b-form>
		</b-container>
	</div>
</template>
<script>
import {HTTP} from '../../services/HttpService'
import {authenticationService} from '../../services/AuthenticationService'

export default {
  name: 'ChangePassword',
  data: () => ({
    oldPassword: null,
    newPassword: null,
    verifyPassword: null
  }),
  methods: {
    changePassword (event) {
      event.preventDefault()
      const formData = new FormData()
      formData.append('oldPassword', this.oldPassword)
      formData.append('newPassword', this.newPassword)
      formData.append('verifyPassword', this.verifyPassword)
      HTTP.post('api/security/password', formData)
        .then(response => {
          authenticationService.updateCredential(this.newPassword)
          this.$swal({
            icon: 'success',
            title: 'Success',
            text: 'Your password has been successfully changed'
          }).then(response => {
            this.$router.push({
              name: 'DashboardPage'
            })
          })
        })
        .catch(e => {
          this.$swal({
            icon: 'error',
            title: 'Failed',
            text: 'An error occurred updating your password.'
          })
        })
    },
    cancel () {
      this.$router.push({
        name: 'HomePage'
      })
    }
  },
  created () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// ChangePasswordPage.vue?22cf005e